/**
 * Utility functions for checking if a UUID exists in the grow goals data
 */
import growGoals from './goals_index.json'

/**
 * Check if a goal UUID exists in the growGoals map
 * @param {string} uuid - The UUID to check
 * @returns {boolean} - True if the UUID exists in the growGoals map, false otherwise
 */
export function hasGrowGoal(uuid) {
  if (!uuid) return false

  // Check if the UUID exists as a key in the growGoals object
  return Object.prototype.hasOwnProperty.call(growGoals, uuid)
}